import Vue from 'vue'
import Router from 'vue-router'

// 重复点击路由报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

/* -------------------password----------------------- */
/* -------------------password----------------------- */
import login from '@/components/password/login/login.vue'
import gapSticklogin from '@/components/password/gapSticklogin'
import waterSystemlogin from '@/components/password/waterSystemlogin'
import admin from '@/components/password/admin'
import changePsw from '@/components/password/changePsw'
/* -------------------password----------------------- */
/* -------------------password----------------------- */

/* -------------------dynamicRoute1监控中心、实时监测、应急处理----------------------- */
/* -------------------dynamicRoute1监控中心、实时监测、应急处理----------------------- */
import home from '@/components/dynamicRoute1/home'
import homeYZ from '@/components/dynamicRoute1/home copy'

import remoteControl from '@/components/remoteControl/index.vue'

import securityHome from '@/components/dynamicRoute1/securityHome'

import accessLogin from '@/components/password/accessLogin/accessLogin'
//实时监测
import lv2 from '@/components/dynamicRoute1/lv2'
import lv3 from '@/components/dynamicRoute1/lv2/lv3'
import demo from '@/components/dynamicRoute1/lv2/demo'
import continuing from '@/components/dynamicRoute1/lv2/continuing'
import camera from '@/components/dynamicRoute1/lv2/camera'

import appMonitorIndex from '@/components/dynamicRoute1/lv2/appMonitor/appMonitorIndex'
import firefightingEquipment from '@/components/dynamicRoute1/lv2/appMonitor/firefightingEquipment'
// import _Devices from '@/components/dynamicRoute1/appMonitor/devices'
// import _camera from '@/components/dynamicRoute1/appMonitor/camera'
// 展示测试设备总览
// import home from '@/components/home/testpage/testHome'
import home2 from '@/components/dynamicRoute1/home/testpage/testHome2'
import appMonitorNew from '@/components/dynamicRoute1/appMonitorNew'
import emergencyHandle from '@/components/dynamicRoute1/emergencyHandle'
/* --------------------dynamicRoute1监控中心、实时监测、应急处理---------------------- */
/* --------------------dynamicRoute1监控中心、实时监测、应急处理---------------------- */

/* --------------------dynamicRoute2系统配置---------------------- */
/* --------------------dynamicRoute2系统配置---------------------- */
import ToolManagement from '@/components/dynamicRoute2/systemConfiguration/first/ToolManagement'
import areaToDept from '@/components/dynamicRoute2/systemConfiguration/first/ToolManagement/areaToDept'
import handleAllAlarm from '@/components/dynamicRoute2/systemConfiguration/first/ToolManagement/handleAllAlarm'
import statusUpdate from '@/components/dynamicRoute2/systemConfiguration/first/ToolManagement/statusUpdate'

import allSystemConfiguration from '@/components/dynamicRoute2/systemConfiguration/allSystemConfiguration'
import _allSystemConfiguration from '@/components/dynamicRoute2/systemConfiguration/allSystemConfiguration'

import allSystem from '@/components/dynamicRoute2/systemConfiguration/first/system/allSystem'
import allConfiguration from '@/components/dynamicRoute2/systemConfiguration/first/configuration/allConfiguration'

import role from '@/components/dynamicRoute2/systemConfiguration/first/system/role'
import _role from '@/components/dynamicRoute2/systemConfiguration/first/system/role'
import sms from '@/components/dynamicRoute2/systemConfiguration/first/system/sms'
import user from '@/components/dynamicRoute2/systemConfiguration/first/system/user'
import usergroup from '@/components/dynamicRoute2/systemConfiguration/first/system/usergroup'
import concatUser from '@/components/dynamicRoute2/systemConfiguration/first/system/concatUser'
import dataDictionary from '@/components/dynamicRoute2/systemConfiguration/first/configuration/dataDictionary'
// import timingTask from '@/components/dynamicRoute2/systemConfiguration/first/configuration/timingTask'
import alarm from '@/components/dynamicRoute2/systemConfiguration/first/configuration/alarm'
import region from '@/components/dynamicRoute2/systemConfiguration/first/system/region/index'
import owner from '@/components/dynamicRoute2/systemConfiguration/first/system/owner/index'
// 应急处置管理
import emergencyDisposal from '@/components/dynamicRoute2/systemConfiguration/first/system/emergencyDisposal'
//设备管理
import allDevice from '@/components/dynamicRoute2/systemConfiguration/first/device/allDevice'
import deadline from '@/components/dynamicRoute2/systemConfiguration/first/device/deadline'
import WarningNotice from '@/components/dynamicRoute2/systemConfiguration/first/device/WarningNotice' // 设备告警通知配置
import deviceManagement from '@/components/dynamicRoute2/systemConfiguration/first/device/deviceManagement'
import deviceManufacturer from '@/components/dynamicRoute2/systemConfiguration/first/device/deviceManufacturer'
import deviceType from '@/components/dynamicRoute2/systemConfiguration/first/device/deviceType'
import trigger from '@/components/dynamicRoute2/systemConfiguration/first/device/trigger'
import gataway from '@/components/dynamicRoute2/systemConfiguration/first/device/gataway'
import deviceConfig from '@/components/dynamicRoute2/systemConfiguration/first/device/deviceConfig'
import tridev from '@/components/dynamicRoute2/systemConfiguration/first/device/tridev/index'
import tridevAdd from '@/components/dynamicRoute2/systemConfiguration/first/device/tridev/add'
import acquisitionGate from '@/components/dynamicRoute2/systemConfiguration/first/device/acquisitionGate'
import RTU from '@/components/dynamicRoute2/systemConfiguration/first/device/RTU'
import Devices from '@/components/dynamicRoute2/devices'
import alarmWeighting from '@/components/dynamicRoute2/systemConfiguration/first/device/alarm/weighting' // 设备告警加权配置
// 批量打点
import regionLead from '@/components/dynamicRoute2/systemConfiguration/first/system/region copy/index'
import deviceLead from '@/components/dynamicRoute2/systemConfiguration/first/device/deviceLead'
import alarmCorrelation from '@/components/dynamicRoute2/systemConfiguration/first/device/alarmCorrelation'
import alarmDiagnosis from '@/components/dynamicRoute2/systemConfiguration/first/device/alarmDiagnosis'
import registerDevice from '@/components/dynamicRoute2/systemConfiguration/first/device/registerDevice'
import operateLog from '@/components/dynamicRoute2/systemConfiguration/first/ToolManagement/operateLog/index'
import dataSend from '@/components/dynamicRoute2/systemConfiguration/first/ToolManagement/dataSend/index'
import followTest from '@/components/dynamicRoute2/systemConfiguration/first/ToolManagement/followTest/index'

//状态检测
import statusDetection from '@/components/dynamicRoute2/systemConfiguration/first/statusDetection/index'

//视频管理
import allVedio from '@/components/dynamicRoute2/systemConfiguration/first/vedio/allVedio'
import equipment from '@/components/dynamicRoute2/systemConfiguration/first/vedio/equipment'
import platform from '@/components/dynamicRoute2/systemConfiguration/first/vedio/platform'
//单位管理
import basicSystem from '@/components/dynamicRoute2/systemConfiguration/first/basic/index'
import department from '@/components/dynamicRoute2/systemConfiguration/first/basic/department/index'
import basicPersonnel from '@/components/dynamicRoute2/systemConfiguration/first/basic/personnel/index'
import basicInfo from '@/components/dynamicRoute2/systemConfiguration/first/basic/info/index'

// 告警配置
// import alarmLevel from "@/components/dynamicRoute2/systemConfiguration/first/device/alarm/alarmLevel/index";
import alarmRules from '@/components/dynamicRoute2/systemConfiguration/first/device/alarm/alarmRules/index'
import alarmPerson from '@/components/dynamicRoute2/systemConfiguration/first/configuration/alarmPerson'
/* --------------------dynamicRoute2系统配置---------------------- */
/* --------------------dynamicRoute2系统配置---------------------- */

/* --------------------dynamicRoute3业务管理---------------------- */
/* --------------------dynamicRoute3业务管理---------------------- */
import allManagement from '@/components/dynamicRoute3/management/allManagement'
//业务管理
import instructions from '@/components/dynamicRoute3/management/instructions/allinstructions'
import instructionRecord from '@/components/dynamicRoute3/management/instructions/instructionRecord'
import instruction from '@/components/dynamicRoute3/management/instructions/instruction'
import firmware from '@/components/dynamicRoute3/management/firmware'
import chargingStation from '@/components/dynamicRoute3/management/chargingStation'
import exhibitionHall from '@/components/dynamicRoute3/management/exhibitionHall'
import VRShow from '@/components/dynamicRoute3/management/exhibitionHall/VRShow'
import electronicFence from '@/components/dynamicRoute3/management/exhibitionHall/electronicFence'
import ocr from '@/components/dynamicRoute3/management/exhibitionHall/ocr'
import expertGuidance from '@/components/dynamicRoute1/expertGuidance'
//任务处置中心
import allMission from '@/components/dynamicRoute3/management/mission/allMission'
import hierarchy from '@/components/dynamicRoute3/management/mission/hierarchy'
import personnel from '@/components/dynamicRoute3/management/mission/personnel'
import missionPlan from '@/components/dynamicRoute3/management/mission/missionPlan'
import missionList from '@/components/dynamicRoute3/management/mission/missionList'
import myAgent from '@/components/dynamicRoute3/management/mission/myAgent'
//巡检
import xunjian from '@/components/dynamicRoute3/management/xunjian'
import xunjianPlan from '@/components/dynamicRoute3/management/xunjian/xunjianPlan'
import xunjianPreArranged from '@/components/dynamicRoute3/management/xunjian/xunjianPreArranged'
import xunjianMission from '@/components/dynamicRoute3/management/xunjian/xunjianMission'
import xunjianConfig from '@/components/dynamicRoute3/management/xunjian/xunjianConfig'
//隐患
import yinhuan from '@/components/dynamicRoute3/management/yinhuan'
import yinhuanMine from '@/components/dynamicRoute3/management/yinhuan/mine'
import yinhuanDepartment from '@/components/dynamicRoute3/management/yinhuan/department'
import yinhuanReport from '@/components/dynamicRoute3/management/yinhuan/report'
//维保管理
import upkeep from '@/components/dynamicRoute3/management/upkeep/index'
import upkeepCompany from '@/components/dynamicRoute3/management/upkeep/upkeepCompany'
import upkeepRecord from '@/components/dynamicRoute3/management/upkeep/upkeepRecord'
import wbhtgl from '@/components/dynamicRoute3/management/upkeep/wbhtgl'
import wbrwgl from '@/components/dynamicRoute3/management/upkeep/wbrwgl'
// 新的维保管理
import wbManage from '@/components/dynamicRoute3/management/wbManage/index'
import wbContentItems from '@/components/dynamicRoute3/management/wbManage/wbContentItems'
import wbTemplate from '@/components/dynamicRoute3/management/wbManage/wbTemplate'
import wbProject from '@/components/dynamicRoute3/management/wbManage/wbProject'
import wbTask from '@/components/dynamicRoute3/management/wbManage/wbTask'
import inspectSummary from '@/components/dynamicRoute3/management/wbManage/inspectSummary'
import inspectLedger from '@/components/dynamicRoute3/management/wbManage/inspectLedger'
import maintainTask from '@/components/dynamicRoute3/management/wbManage/maintainTask'
import maintainSummary from '@/components/dynamicRoute3/management/wbManage/maintainSummary'
import workRecord from '@/components/dynamicRoute3/management/wbManage/workRecord'
import monthReport from '@/components/dynamicRoute3/management/wbManage/monthReport'
// 设备巡检管理
import deviceInspect from '@/components/dynamicRoute3/management/deviceInspect/index'
import inspectContent from '@/components/dynamicRoute3/management/deviceInspect/inspectContent'
import inspectDeviceManage from '@/components/dynamicRoute3/management/deviceInspect/inspectDeviceManage'
import inspectTaskManage from '@/components/dynamicRoute3/management/deviceInspect/inspectTaskManage'
import repairTaskManage from '@/components/dynamicRoute3/management/deviceInspect/repairTaskManage'
import deviceExpireRemind from '@/components/dynamicRoute3/management/deviceInspect/deviceExpireRemind'
// 楼宇信息管理
import buildManage from '@/components/dynamicRoute3/management/buildingManage/buildManage/index'
//督查督办
import dcdb from '@/components/dynamicRoute3/management/dcdb'
import jstxsgl from '@/components/dynamicRoute3/management/dcdb/jstxsgl'
//达标测评
import standardEvaluation from '@/components/dynamicRoute3/management/standardEvaluation'
import standardManagement from '@/components/dynamicRoute3/management/standardEvaluation/standardManagement'
import selfEvaluation from '@/components/dynamicRoute3/management/standardEvaluation/selfEvaluation'
import scoringConfiguration from '@/components/dynamicRoute3/management/standardEvaluation/scoringConfiguration'
import scoreManagement from '@/components/dynamicRoute3/management/standardEvaluation/scoreManagement'
import ratingStatistics from '@/components/dynamicRoute3/management/standardEvaluation/ratingStatistics'
// 告警管理
import alarmSystem from '@/components/dynamicRoute3/management/alarm/index'
import relaAlarm from '@/components/dynamicRoute3/management/alarm/relaAlarm'
import historAlarm from '@/components/dynamicRoute3/management/alarm/historAlarm'
import downloadAlarm from '@/components/dynamicRoute3/management/alarm/downloadAlarm'
import filing from '@/components/dynamicRoute3/management/alarm/filing'
import droneAlarm from '@/components/dynamicRoute3/management/alarm/droneAlarm'
// 预警管理
import warningManage from '@/components/dynamicRoute3/management/warningManage/index'
import warningPlan from '@/components/dynamicRoute3/management/warningManage/warningPlan'
import relaWarning from '@/components/dynamicRoute3/management/warningManage/relaWarning'
// 在线考试
import exam from '@/components/dynamicRoute3/management/exam/index'
import testType from '@/components/dynamicRoute3/management/exam/testType/index'
import testQuestion from '@/components/dynamicRoute3/management/exam/testQuestion/index'
import testPaper from '@/components/dynamicRoute3/management/exam/testPaper/index'
import taskManage from '@/components/dynamicRoute3/management/exam/taskManage/index'

// 在线学习
import news from '@/components/dynamicRoute3/management/studyonline'
import classification from '@/components/dynamicRoute3/management/studyonline/subject/classification.vue'
import content from '@/components/dynamicRoute3/management/studyonline/subject/content.vue'

// 资产管理
import allAsset from '@/components/dynamicRoute3/management/assetManagement/allAsset.vue'
import assetManagement from '@/components/dynamicRoute3/management/assetManagement/assetManagement.vue'
import assetAgent from '@/components/dynamicRoute3/management/assetManagement/myAgent.vue'
// 一键查岗
import checkThePositionIndex from '@/components/dynamicRoute3/management/checkThePosition/index.vue'
import checkThePosition from '@/components/dynamicRoute3/management/checkThePosition/checkThePosition.vue'
// 智能间隔棒数据查询
import spaceBarData from '@/components/dynamicRoute3/management/spaceBarData/index'
import viewEvent from '@/components/dynamicRoute3/management/viewEvent/index'
import actionRecord from '@/components/dynamicRoute3/management/actionRecord/index'
/* --------------------dynamicRoute3业务管理---------------------- */
/* --------------------dynamicRoute3业务管理---------------------- */

/* --------------------dynamicRoute4数据分析---------------------- */
/* --------------------dynamicRoute4数据分析---------------------- */

// 数据分析
import dataAnalysis from '@/components/dynamicRoute4/dataAnalysis/index'
import reportForms from '@/components/dynamicRoute4/dataAnalysis/reportForms/index'
import alarmStatistics from '@/components/dynamicRoute4/dataAnalysis/reportForms/alarmStatistics'
import dataStatistics from '@/components/dynamicRoute4/dataAnalysis/reportForms/dataStatistics'
import deviceStatistics from '@/components/dynamicRoute4/dataAnalysis/reportForms/deviceStatistics'
import deviceData from '@/components/dynamicRoute4/dataAnalysis/deviceData/index'
import electricData from '@/components/dynamicRoute4/dataAnalysis/deviceData/electricData'
import historicalData from '@/components//dynamicRoute4/dataAnalysis/deviceData/historicalData'
import alarmSubscribe from '@/components/dynamicRoute4/dataAnalysis/deviceData/alarmSubscribe'
import historySubscribe from '@/components/dynamicRoute4/dataAnalysis/deviceData/historySubscribe'

// 告警短信 告警语音
import alarmSms from '@/components/dynamicRoute4/dataAnalysis/deviceData/alarmSms'
import alarmVoice from '@/components/dynamicRoute4/dataAnalysis/deviceData/alarmVoice'
import monitorData from '@/components/dynamicRoute4/dataAnalysis/deviceData/monitorData'

import YHstatistics from '@/components/dynamicRoute4/dataAnalysis/reportForms/YHstatistics'
import XJstatistics from '@/components/dynamicRoute4/dataAnalysis/reportForms/XJstatistics'
import XXstatistics from '@/components/dynamicRoute4/dataAnalysis/reportForms/XXstatistics'

//ai查询
import aiQuery from '@/components/dynamicRoute4/dataAnalysis/aiQuery/index'
import AiQuery from '@/components/dynamicRoute4/dataAnalysis/aiQuery/AiQuery'
/* --------------------dynamicRoute4数据分析---------------------- */
/* --------------------dynamicRoute4数据分析---------------------- */

/* 可视化 */
/* 可视化 */
import visualizeIndex from '@/components/visualize/index'
/* 可视化 */
/* 可视化 */

import fireStation from '@/components/fireStation/index'
import visualizeWrj from '@/components/visualize/visualizeWrj/visualizeHome.vue'
import visualizeWrj2 from '@/components/visualize/visualizeWrj/visualizeHome2.vue'
import spacerBar from '@/components/spacerBar/index.vue'
import pumpMonitor from '@/components/pumpMonitor/index.vue'
import waterSystem from '@/components/waterSystem/index.vue'
import waterSystemHome from '@/components/waterSystem/waterSystemHome/index.vue'

import MonitoringWarning from '@/components/dynamicRoute1/monitorWarning/index.vue'

import dailySchedule from '@/components/maintenance/projectManage/projectSchedule/dailySchedule'
Vue.use(Router)

const dynamicRoute1 = [
  {
    path: '/home',
    name: 'home',
    title: '监控中心',
    component: home,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/remoteControl',
    name: 'remoteControl',
    title: '远控中心',
    component: remoteControl,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/MonitoringWarning',
    name: 'MonitoringWarning',
    title: '配电柜预警',
    component: MonitoringWarning,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/homeYZ',
    name: 'homeYZ',
    title: '监控中心',
    component: homeYZ,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/securityHome',
    name: 'securityHome',
    title: 'AI安防识别',
    component: securityHome,
    meta: {
      requireAuth: true
    }
  },

  {
    path: '/appMonitor',
    name: 'appMonitor',
    title: '实时监测',
    component: lv2,
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'freedom1',
        name: 'freedom1',
        title: '自由1',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'freedom1',
            name: 'freedom1',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'freedom1Devices',
            name: 'freedom1Devices',
            title: '设备列表',
            parent: 'fireMonitor',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'fireMonitor'
            }
          }
        ]
      },
      {
        path: 'freedom2',
        name: 'freedom2',
        title: '自由2',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'freedom2',
            name: 'freedom2',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'freedom2Devices',
            name: 'freedom2Devices',
            title: '设备列表',
            parent: 'fireMonitor',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'fireMonitor'
            }
          }
        ]
      },
      {
        path: 'freedom3',
        name: 'freedom3',
        title: '自由3',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'freedom3',
            name: 'freedom3',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'freedom3Devices',
            name: 'freedom3Devices',
            title: '设备列表',
            parent: 'fireMonitor',
            component: Devices,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'freedom4',
        name: 'freedom4',
        title: '自由4',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'freedom4',
            name: 'freedom4',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'freedom4Devices',
            name: 'freedom4Devices',
            title: '设备列表',
            parent: 'fireMonitor',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'fireMonitor'
            }
          }
        ]
      },
      {
        path: 'SubsidenceMonitoring',
        name: 'SubsidenceMonitoring',
        title: '沉降监测',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'SubsidenceMonitoringSystem',
            name: 'SubsidenceMonitoringSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'SubsidenceMonitoringDevices',
            name: 'SubsidenceMonitoringDevices',
            title: '设备列表',
            parent: 'SubsidenceMonitoring',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'SubsidenceMonitoring'
            }
          }
        ]
      },
      {
        path: 'CrackMonitoring',
        name: 'CrackMonitoring',
        title: '裂缝监测',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'CrackMonitoringSystem',
            name: 'CrackMonitoringSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'CrackMonitoringDevices',
            name: 'CrackMonitoringDevices',
            title: '设备列表',
            parent: 'CrackMonitoring',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'CrackMonitoring'
            }
          }
        ]
      },
      {
        path: 'SlopeMonitoring',
        name: 'SlopeMonitoring',
        title: '倾斜监测',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'SlopeMonitoringSystem',
            name: 'SlopeMonitoringSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'SlopeMonitoringDevices',
            name: 'SlopeMonitoringDevices',
            title: '设备列表',
            parent: 'SlopeMonitoring',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'SlopeMonitoring'
            }
          }
        ]
      },
      {
        path: 'fireMonitor',
        name: 'fireMonitor',
        title: '火灾预防',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'fireMonitorSystem',
            name: 'fireMonitorSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'fireMonitorDevices',
            name: 'fireMonitorDevices',
            title: '设备列表',
            parent: 'fireMonitor',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'fireMonitor'
            }
          }
        ]
      },
      {
        path: 'waterMonitor',
        name: 'waterMonitor',
        title: '消防用水',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'waterMonitorSystem',
            name: 'waterMonitorSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'waterMonitorDevices',
            name: 'waterMonitorDevices',
            title: '设备列表',
            parent: 'waterMonitor',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'waterMonitor'
            }
          }
        ]
      },
      {
        path: 'electricMonitor',
        name: 'electricMonitor',
        title: '电气火灾',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'electricMonitorSystem',
            name: 'electricMonitorSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'electricMonitorDevices',
            name: 'electricMonitorDevices',
            title: '设备列表',
            parent: 'electricMonitor',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'electricMonitor'
            }
          }
        ]
      },

      {
        path: 'fireWarning',
        name: 'fireWarning',
        title: '火灾预警',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'fireWarningSystem',
            name: 'fireWarningSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'fireWarningDevices',
            name: 'fireWarningDevices',
            title: '设备列表',
            parent: 'fireWarning',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'fireWarning'
            }
          }
        ]
      },

      {
        path: 'fireAlarm',
        name: 'fireAlarm',
        title: '火灾报警',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'fireAlarmSystem',
            name: 'fireAlarmSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'fireAlarmDevices',
            name: 'fireAlarmDevices',
            title: '设备列表',
            parent: 'fireAlarm',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'fireAlarm'
            }
          }
        ]
      },

      {
        path: 'ESMonitoring',
        name: 'ESMonitoring',
        title: '用电安全监控系统',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'ESMonitoringSystem',
            name: 'ESMonitoringSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'ESMonitoringDevices',
            name: 'ESMonitoringDevices',
            title: '设备列表',
            parent: 'ESMonitoring',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'ESMonitoring'
            }
          }
        ]
      },

      {
        path: 'SWPMonitoring',
        name: 'SWPMonitoring',
        title: '喷淋水压监测',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'SWPMonitoringSystem',
            name: 'SWPMonitoringSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'SWPMonitoringDevices',
            name: 'SWPMonitoringDevices',
            title: '设备列表',
            parent: 'SWPMonitoring',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'SWPMonitoring'
            }
          }
        ]
      },

      {
        path: 'fireHydrant',
        name: 'fireHydrant',
        title: '室内消火栓监测',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'fireHydrantSystem',
            name: 'fireHydrantSystem',
            title: '设备总览',
            parent: 'fireHydrant',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'fireHydrantDevices',
            name: 'fireHydrantDevices',
            title: '设备列表',
            parent: 'fireHydrant',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'fireHydrant'
            }
          }
        ]
      },

      {
        path: 'liquidLevel',
        name: 'liquidLevel',
        title: '消防液位监测',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'liquidLevelSystem',
            name: 'liquidLevelSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'liquidLevelDevices',
            name: 'liquidLevelDevices',
            title: '设备列表',
            parent: 'liquidLevel',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'liquidLevel'
            }
          }
        ]
      },

      {
        path: 'chargingPile',
        name: 'chargingPile',
        title: '充电桩监测',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'chargingPileSystem',
            name: 'chargingPileSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'chargingPileDevices',
            name: 'chargingPileDevices',
            title: '设备列表',
            parent: 'chargingPile',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'chargingPile'
            }
          }
        ]
      },
      {
        path: 'lineCheck',
        name: 'lineCheck',
        title: '线路状态监测',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'lineCheckSystem',
            name: 'lineCheckSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'lineCheckDevices',
            name: 'lineCheckDevices',
            title: '设备列表',
            parent: 'lineCheck',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'lineCheck'
            }
          }
        ]
      },
      {
        path: 'tempHumidity',
        name: 'tempHumidity',
        title: '温湿度',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'tempHumiditySystem',
            name: 'tempHumiditySystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'tempHumidityDevices',
            name: 'tempHumidityDevices',
            title: '设备列表',
            parent: 'tempHumidity',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'tempHumidity'
            }
          }
        ]
      },

      {
        path: 'AIFireFighting',
        name: 'AIFireFighting',
        title: '智慧消防',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'AIFireFightingSystem',
            name: 'AIFireFightingSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'AIFireFightingDevices',
            name: 'AIFireFightingDevices',
            title: '设备列表',
            parent: 'AIFireFighting',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'AIFireFighting'
            }
          }
        ]
      },
      {
        path: 'AIElectric',
        name: 'AIElectric',
        title: '智慧用电',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'AIElectricSystem',
            name: 'AIElectricSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'AIElectricDevices',
            name: 'AIElectricDevices',
            title: '设备列表',
            parent: 'AIElectric',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'AIElectric'
            }
          }
        ]
      },
      {
        path: 'FCengine',
        name: 'FCengine',
        title: '消控主机',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'FCengineSystem',
            name: 'FCengineSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'FCengineDevices',
            name: 'FCengineDevices',
            title: '设备列表',
            parent: 'FCengine',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'FCengine'
            }
          }
        ]
      },
      {
        path: 'electromobile',
        name: 'electromobile',
        title: '视频监控',
        component: camera,
        meta: {
          requireAuth: true
        }
        // children: [
        //   {
        //     path: "electromobile",
        //     name: "electromobile",
        //     title: "设备总览",
        //     component: camera,
        //     meta: {
        //       requireAuth: true
        //     }
        //   },
        // {
        //   path: "electromobileDevices",
        //   name: "electromobileDevices",
        //   title: "设备列表",
        //   parent: 'electromobile',
        //   component: Devices,
        //   meta: {
        //     requireAuth: true
        //   }
        // }
        // ]
      },
      {
        path: 'PumpControlCabinet',
        name: 'PumpControlCabinet',
        title: '水泵控制柜监测',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'PumpControlCabinetSystem',
            name: 'PumpControlCabinetSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'PumpControlDevices',
            name: 'PumpControlDevices',
            title: '设备列表',
            parent: 'PumpControlCabinet',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'PumpControlCabinet'
            }
          }
        ]
      },
      {
        path: 'remotePumpControlCabinet',
        name: 'remotePumpControlCabinet',
        title: '远程水泵控制柜',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'remotePumpControlCabinetSystem',
            name: 'remotePumpControlCabinetSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'remotePumpControlDevices',
            name: 'remotePumpControlDevices',
            title: '设备列表',
            parent: 'remotePumpControlCabinet',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'remotePumpControlCabinet'
            }
          }
        ]
      },
      {
        path: 'wurenji',
        name: 'wurenji',
        title: '无人机应用',
        component: lv3,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'wurenjiSystem',
            name: 'wurenjiSystem',
            title: '设备总览',
            component: continuing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'wurenjiDevices',
            name: 'wurenjiDevices',
            title: '设备列表',
            parent: 'wurenji',
            component: Devices,
            meta: {
              requireAuth: true,
              parent: 'wurenji'
            }
          }
        ]
      },
      {
        path: 'firefightingEquipment',
        name: 'firefightingEquipment',
        title: '消防设备',
        component: firefightingEquipment,
        meta: {
          requireAuth: true,
          parent: 'firefightingEquipment'
        }
      },
      {
        path: 'waterPressureMonitoring',
        name: 'waterPressureMonitoring',
        title: '水压监测',
        component: Devices,
        meta: {
          requireAuth: true,
          parent: 'waterPressureMonitoring'
        }
      }
    ]
  },
  {
    path: '/appMonitorNew',
    name: 'appMonitorNew',
    title: '实时监测新',
    component: appMonitorNew,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    title: '消防维保',
    component: () => import('@/components/maintenance/index.vue'),
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'databoard',
        name: 'databoard',
        title: '首页看板',
        component: () => import('@/components/maintenance/databoard/index.vue'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'projectManage',
        name: 'projectManage',
        title: '项目管理',
        component: () => import('@/components/maintenance/projectManage/index.vue'),
        meta: {
          title: '项目管理',
          requireAuth: true
        },
        children: [
          {
            path: 'wbPlan',
            name: 'wbPlan',
            title: '维保计划',
            component: () => import('@/components/maintenance/projectManage/wbPlan/index.vue'),
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'wbOrder',
            name: 'wbOrder',
            title: '维保工单',
            component: () => import('@/components/maintenance/projectManage/wbOrder/index.vue'),
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'projectSchedule',
            name: 'projectSchedule',
            title: '项目排期',
            component: () =>
              import('@/components/maintenance/projectManage/projectSchedule/index.vue'),
            meta: {
              title: '项目排期',
              requireAuth: true
            }
          },
          {
            path: 'wbReport',
            name: 'wbReport',
            title: '维保报告',
            component: () => import('@/components/maintenance/projectManage/wbReport/index.vue'),
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'systemConfiguration',
        name: 'systemConfiguration',
        title: '系统管理',
        component: () =>
          import('@/components/maintenance/systemConfiguration/allSystemConfiguration.vue'),
        meta: {
          title: '系统管理',
          requireAuth: true
        },
        icon: 'icon-xitongpeizhi',
        children: [
          {
            path: 'role',
            name: '_role',
            title: '维保角色',
            component: () =>
              import('@/components/maintenance/systemConfiguration/first/system/role/index.vue'),
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'user',
            name: '_user',
            title: '维保用户',
            component: user,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'usergroup',
            name: '_usergroup',
            title: '岗位管理',
            component: usergroup,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'basic/basicSystem',
            name: '_basicSystem',
            title: '服务商管理',
            component: basicInfo,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'department',
            name: '_department',
            title: '服务商部门管理',
            component: department,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'basicManage',
            name: '_basicManage',
            title: '单位管理',
            component: () =>
              import(
                '@/components/maintenance/systemConfiguration/first/basic/basicManage/index.vue'
              ),
            meta: {
              title: '单位管理',
              requireAuth: true
            }
          },
          {
            path: 'contractManage',
            name: 'contractManage',
            title: '合同管理',
            component: () =>
              import(
                '@/components/maintenance/systemConfiguration/first/basic/contractManage/index.vue'
              ),
            meta: {
              title: '合同管理',
              requireAuth: true
            }
          }
        ]
      }
    ]
  },
  {
    path: '/emergencyHandle',
    name: 'emergencyHandle',
    title: '应急处理',
    component: emergencyHandle,
    meta: {
      requireAuth: true
    }
  }
]
const dynamicRoute2 = [
  {
    path: '/systemConfiguration/allSystemConfiguration',
    name: 'allSystemConfiguration',
    title: '系统配置',
    component: allSystemConfiguration,
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'system/allSystem',
        name: 'allSystem',
        title: '系统管理',
        component: allSystem,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'sms',
            name: 'sms',
            title: '模板短信管理',
            component: sms,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'system/emergencyDisposal',
            name: 'emergencyDisposal',
            title: '应急处置管理',
            component: emergencyDisposal,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'system/role',
            name: 'role',
            title: '角色管理',
            component: role,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'system/user',
            name: 'user',
            title: '用户管理',
            component: user,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'system/usergroup',
            name: 'usergroup',
            title: '用户组管理',
            component: usergroup,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'system/region',
            name: 'region',
            title: '区域管理',
            component: region,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'system/owner',
            name: 'owner',
            title: '业主管理',
            component: owner,
            meta: {
              requireAuth: true
            }
          }
          // {
          //   path: "system/concatUser/:id/:groupName",
          //   name: "concatUser",
          //   title: "关联用户",
          //   component: concatUser,
          //   meta: {
          //     requireAuth: true
          //   }
          // }
        ]
      },
      {
        path: 'device/allDevice',
        name: 'allDevice',
        title: '设备管理',
        component: allDevice,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'device/deviceManagement',
            name: 'deviceManagement',
            title: '设备管理',
            component: deviceManagement,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'device/deviceManufacturer',
            name: 'deviceManufacturer',
            title: '设备厂家管理',
            component: deviceManufacturer,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'device/deviceType',
            name: 'deviceType',
            title: '设备型号管理',
            component: deviceType,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'device/trigger',
            name: 'trigger',
            title: '阈值管理',
            component: trigger,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'device/alarmWeighting',
            name: 'alarmWeighting',
            title: '告警加权',
            component: alarmWeighting,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'device/acquisitionGate',
            name: 'acquisitionGate',
            title: '采集网关管理',
            component: acquisitionGate,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'device/gataway',
            name: 'gataway',
            title: '网关设备关联',
            component: gataway,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'device/deviceConfig',
            name: 'deviceConfig',
            title: '设备配置',
            component: deviceConfig,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'device/deadline',
            name: 'deadline',
            title: '设备到期管理',
            component: deadline,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'device/WarningNotice',
            name: 'WarningNotice',
            title: '设备告警通知配置',
            component: WarningNotice,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'device/RTU/:id',
            name: 'RTU',
            title: 'RTU列表',
            component: RTU,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'configuration/allConfiguration',
        name: 'allConfiguration',
        title: '方案配置',
        component: allConfiguration,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'configuration/dataDictionary',
            name: 'dataDictionary',
            title: '数据字典配置',
            component: dataDictionary,
            meta: {
              requireAuth: true
            }
          },
          // {
          //   path: 'systemConfiguration/first/configuration/timingTask',
          //   name: 'timingTask',
          //   title: '定时任务配置',
          //   component: timingTask,
          //   meta: {
          //     requireAuth: true
          //   }
          // },
          // {
          //   path: "configuration/alarm",
          //   name: "alarm",
          //   title: "告警方案配置",
          //   component: alarm,
          //   meta: {
          //     requireAuth: true
          //   }
          // },
          {
            path: 'device/alarmRules',
            name: 'alarmRules',
            title: '严重告警配置',
            component: alarmRules,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'device/alarmPerson',
            name: 'alarmPerson',
            title: '告警接收人配置',
            component: alarmPerson,
            meta: {
              requireAuth: true
            }
          }
          // {
          //   path: "device/alarmLevel",
          //   name: "alarmLevel",
          //   title: "告警等级配置",
          //   component: alarmLevel,
          //   meta: {
          //     requireAuth: true
          //   }
          // }
        ]
      },
      {
        path: 'basic/basicSystem',
        name: 'basicSystem',
        title: '单位管理',
        component: basicSystem,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'basicInfo',
            name: 'basicInfo',
            title: '单位信息',
            component: basicInfo,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'department',
            name: 'department',
            title: '部门管理',
            component: department,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'basicPersonnel',
            name: 'basicPersonnel',
            title: '人员管理',
            component: basicPersonnel,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'vedio/allVedio',
        name: 'allVedio',
        title: '视频管理',
        component: allVedio,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'vedio/platform',
            name: 'platform',
            title: '平台管理',
            component: platform,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'vedio/equipment',
            name: 'equipment',
            title: '设备管理',
            component: equipment,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'ToolManagement',
        name: 'ToolManagement',
        title: '工具管理',
        component: ToolManagement,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'device/regionLead',
            name: 'regionLead',
            title: '批量打点',
            component: regionLead,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'device/deviceLead',
            name: 'deviceLead',
            title: '设备导入',
            component: deviceLead,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'areaToDept',
            name: 'areaToDept',
            title: '区域导入部门',
            component: areaToDept,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'handleAllAlarm',
            name: 'handleAllAlarm',
            title: '告警批量处理',
            component: handleAllAlarm,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'statusUpdate',
            name: 'statusUpdate',
            title: '批量状态更新',
            component: statusUpdate,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'device/alarmCorrelation',
            name: 'alarmCorrelation',
            title: '告警配置查询',
            component: alarmCorrelation,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'device/alarmDiagnosis',
            name: 'alarmDiagnosis',
            title: '诊断工具',
            component: alarmDiagnosis,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'device/registerDevice',
            name: 'registerDevice',
            title: '批量注册设备',
            component: registerDevice,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'operateLog',
            name: 'operateLog',
            title: '系统操作日志',
            component: operateLog,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'dataSend',
            name: 'dataSend',
            title: '数据推送',
            component: dataSend,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'statusDetection',
            name: 'statusDetection',
            title: '状态检测',
            component: statusDetection,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'followTest',
            name: 'followTest',
            title: '跟踪测试',
            component: followTest,
            meta: {
              requireAuth: true
            }
          }
        ]
      }
    ]
  }
]

const dynamicRoute3 = [
  {
    path: '/management/allManagement',
    name: 'allManagement',
    title: '业务管理',
    component: allManagement,
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'upkeep',
        name: 'upkeep',
        title: '维保管理',
        component: upkeep,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'upkeep/upkeepCompany',
            name: 'upkeepCompany',
            title: '维保单位管理',
            component: upkeepCompany,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'upkeep/upkeepRecord',
            name: 'upkeepRecord',
            title: '维保记录管理',
            component: upkeepRecord,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'wbhtgl',
            name: 'wbhtgl',
            title: '维保合同管理',
            component: wbhtgl,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'wbrwgl',
            name: 'wbrwgl',
            title: '维保任务管理',
            component: wbrwgl,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'wbManage',
        name: 'wbManage',
        title: '维保管理',
        component: wbManage,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'wbContentItems',
            name: 'wbContentItems',
            title: '维保内容项管理',
            component: wbContentItems,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'wbTemplate',
            name: 'wbTemplate',
            title: '维保模板配置',
            component: wbTemplate,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'wbProject',
            name: 'wbProject',
            title: '维保项目管理',
            component: wbProject,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'wbTask',
            name: 'wbTask',
            title: '维保任务',
            component: wbTask,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'maintainTask',
            name: 'maintainTask',
            title: '维修任务',
            component: maintainTask,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'workRecord',
            name: 'workRecord',
            title: '临时记录',
            component: workRecord,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'maintainSummary',
            name: 'maintainSummary',
            title: '消防安全维修汇总',
            component: maintainSummary,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'inspectSummary',
            name: 'inspectSummary',
            title: '巡检底账汇总',
            component: inspectSummary,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'inspectLedger',
            name: 'inspectLedger',
            title: '巡检台账汇总',
            component: inspectLedger,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'monthReport',
            name: 'monthReport',
            title: '月度维保报告',
            component: monthReport,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'deviceInspect',
        name: 'deviceInspect',
        title: '设备点检管理',
        component: deviceInspect,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'inspectContent',
            name: 'inspectContent',
            title: '点检内容项',
            component: inspectContent,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'inspectDeviceManage',
            name: 'inspectDeviceManage',
            title: '点检设备管理',
            component: inspectDeviceManage,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'inspectTaskManage',
            name: 'inspectTaskManage',
            title: '点检任务管理',
            component: inspectTaskManage,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'repairTaskManage',
            name: 'repairTaskManage',
            title: '维修任务管理',
            component: repairTaskManage,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'deviceExpireRemind',
            name: 'deviceExpireRemind',
            title: '设备到期提醒',
            component: deviceExpireRemind,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        name: 'buildManage',
        path: 'buildManage',
        title: '楼宇信息管理',
        component: buildManage,
        meta: {
          requireAuth: true
        }
      },
      {
        name: 'dcdb',
        path: 'dcdb',
        title: '督查督办',
        component: dcdb,
        meta: {
          requireAuth: true
        },
        children: [
          {
            name: 'jstxsgl',
            path: 'dcdb/jstxsgl',
            title: '警示提醒书管理',
            component: jstxsgl,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        name: 'standardEvaluation',
        path: 'standardEvaluation',
        title: '达标测评',
        component: standardEvaluation,
        meta: {
          requireAuth: true
        },
        children: [
          {
            name: 'standardManagement',
            path: 'standardEvaluation/standardManagement',
            title: '达标管理',
            component: standardManagement,
            meta: {
              requireAuth: true
            }
          },
          {
            name: 'selfEvaluation',
            path: 'standardEvaluation/selfEvaluation',
            title: '达标自评',
            component: selfEvaluation,
            meta: {
              requireAuth: true
            }
          },
          {
            name: 'scoringConfiguration',
            path: 'standardEvaluation/scoringConfiguration',
            title: '评分配置',
            component: scoringConfiguration,
            meta: {
              requireAuth: true
            }
          },
          {
            name: 'scoreManagement',
            path: 'standardEvaluation/scoreManagement',
            title: '评分管理',
            component: scoreManagement,
            meta: {
              requireAuth: true
            }
          },
          {
            name: 'ratingStatistics',
            path: 'standardEvaluation/ratingStatistics',
            title: '评分统计',
            component: ratingStatistics,
            meta: {
              requireAuth: true
            }
          },
        ]
      },
      {
        path: 'firmware',
        name: 'firmware',
        title: '固件升级',
        component: firmware,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'chargingStation',
        name: 'chargingStation',
        title: '充电桩管理',
        component: chargingStation,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'instructions/allinstructions',
        name: 'instructions',
        title: '设备指令',
        component: instructions,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'instructions/instructionRecord',
            name: 'instructionRecord',
            title: '指令记录',
            component: instructionRecord,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'instructions/instruction',
            name: 'instruction',
            title: '指令下发',
            component: instruction,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'alarm/alarmSystem',
        name: 'alarmSystem',
        title: '告警管理',
        component: alarmSystem,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'alarm/relaAlarm',
            name: 'relaAlarm',
            title: '实时告警',
            component: relaAlarm,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'alarm/historAlarm',
            name: 'historAlarm',
            title: '历史告警',
            component: historAlarm,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'alarm/downloadAlarm',
            name: 'downloadAlarm',
            title: '告警下载',
            component: downloadAlarm,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'alarm/filing',
            name: 'filing',
            title: '报备管理',
            component: filing,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'alarm/droneAlarm',
            name: 'droneAlarm',
            title: '无人机告警',
            component: droneAlarm,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'warning/warningManage',
        name: 'warningManage',
        title: '预警管理',
        component: warningManage,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'warning/warningPlan',
            name: 'warningPlan',
            title: '预警方案管理',
            component: warningPlan,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'warning/relaWarning',
            name: 'relaWarning',
            title: '实时预警',
            component: relaWarning,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'management/news',
        name: 'news',
        title: '在线学习',
        component: news,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'management/news/classification',
            name: 'classification',
            title: '分类管理',
            component: classification,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'management/news/content',
            name: 'content',
            title: '内容管理',
            component: content,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'management/exam',
        name: 'exam',
        title: '考试测评',
        component: exam,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'testType',
            name: 'testType',
            title: '试题类别管理',
            component: testType,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'testQuestion',
            name: 'testQuestion',
            title: '试题管理',
            component: testQuestion,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'testPaper',
            name: 'testPaper',
            title: '试卷管理',
            component: testPaper,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'taskManage',
            name: 'taskManage',
            title: '考试管理',
            component: taskManage,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        name: 'xunjian',
        path: 'xunjian',
        title: '巡检管理',
        component: xunjian,
        meta: {
          requireAuth: true
        },
        children: [
          {
            name: 'xunjianConfig',
            path: 'xunjianConfig',
            title: '巡检点配置',
            component: xunjianConfig,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'xunjianPreArranged',
            name: 'xunjianPreArranged',
            component: xunjianPreArranged,
            title: '巡检预案制定',
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'xunjianPlan',
            name: 'xunjianPlan',
            component: xunjianPlan,
            title: '巡检计划制定',
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'xunjianMission',
            name: 'xunjianMission',
            component: xunjianMission,
            title: '巡检任务管理',
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        name: 'yinhuan',
        path: 'yinhuan',
        title: '隐患管理',
        component: yinhuan,
        meta: {
          requireAuth: true
        },
        children: [
          {
            name: 'yinhuanReport',
            path: 'report',
            title: '隐患录入',
            component: yinhuanReport,
            meta: {
              requireAuth: true
            }
          },
          {
            name: 'yinhuanMine',
            path: 'mine',
            title: '我的待办',
            component: yinhuanMine,
            meta: {
              requireAuth: true
            }
          },
          {
            name: 'yinhuanDepartment',
            path: 'department',
            title: '部门隐患',
            component: yinhuanDepartment,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'mission/allMission',
        name: 'allMission',
        title: '任务清单',
        component: allMission,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'mission/hierarchy',
            name: 'hierarchy',
            title: '层级管理',
            component: hierarchy,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'mission/missionPlan',
            name: 'missionPlan',
            title: '任务计划',
            component: missionPlan,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'mission/missionList',
            name: 'missionList',
            title: '任务清单',
            component: missionList,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'mission/myAgent',
            name: 'myAgent',
            title: '我的待办',
            component: myAgent,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'mission/yjylrw',
        name: 'yjylrw',
        title: '应急演练任务',
        component: allMission,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'mission/zzyl',
            name: 'zzyl',
            title: '组织演练',
            component: hierarchy,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'mission/yazd',
            name: 'yazd',
            title: '预案制定',
            component: missionPlan,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'mission/xxcd',
            name: 'xxcd',
            title: '信息存档',
            component: missionList,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'mission/gcgj',
            name: 'gcgj',
            title: '过程跟进',
            component: myAgent,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'exhibitionHall',
        name: 'exhibitionHall',
        title: '展示厅',
        component: exhibitionHall,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'VRShow',
            name: 'VRShow',
            title: 'VR展厅',
            component: VRShow,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'electronicFence',
            name: 'electronicFence',
            title: '电子围栏',
            component: electronicFence,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'ocr',
            name: 'ocr',
            title: 'ocr识别',
            component: ocr,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: '/expertGuidance',
        name: 'expertGuidance',
        title: '专家指导',
        component: expertGuidance,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'allAsset',
        name: 'allAsset',
        title: '资产管理',
        component: allAsset,
        children: [
          {
            path: 'assetManagement',
            name: 'assetManagement',
            title: '资产管理',
            component: assetManagement,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'assetAgent',
            name: 'assetAgent',
            title: '我的代办',
            component: assetAgent,
            meta: {
              requireAuth: true
            }
          }
        ],
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'checkThePosition',
        name: 'checkThePosition',
        title: '一键查岗',
        component: checkThePosition,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'spaceBarData',
        name: 'spaceBarData',
        title: '智能间隔棒',
        component: spaceBarData,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'viewEvent',
        name: 'viewEvent',
        title: '事件查看',
        component: viewEvent,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'actionRecord',
        name: 'actionRecord',
        title: '操作记录',
        component: actionRecord,
        meta: {
          requireAuth: true
        }
      }
    ]
  }
]

const dynamicRoute4 = [
  {
    path: '/dataAnalysis',
    name: 'dataAnalysis',
    title: '数据分析',
    component: dataAnalysis,
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'reportForms',
        name: 'reportForms',
        title: '统计报表',
        component: reportForms,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'deviceStatistics',
            name: 'deviceStatistics',
            title: '设备统计',
            component: deviceStatistics,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'alarmStatistics',
            name: 'alarmStatistics',
            title: '告警统计',
            component: alarmStatistics,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'dataStatistics',
            name: 'dataStatistics',
            title: '数据流统计',
            component: dataStatistics,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'YHstatistics',
            name: 'YHstatistics',
            title: '隐患统计',
            component: YHstatistics,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'XJstatistics',
            name: 'XJstatistics',
            title: '巡检统计',
            component: XJstatistics,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'XXstatistics',
            name: 'statistics',
            title: '学习统计',
            component: XXstatistics,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'deviceData',
        redirect: 'deviceData/historicalData',
        name: 'deviceData',
        title: '设备数据',
        component: deviceData,
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: 'historicalData',
            name: 'historicalData',
            title: '历史数据',
            component: historicalData,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'monitorData',
            name: 'monitorData',
            title: '监测数据查询',
            component: monitorData,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'electricData',
            name: 'electricData',
            title: '电量数据',
            component: electricData,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'alarmSms',
            name: 'alarmSms',
            title: '告警短信',
            component: alarmSms,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'alarmVoice',
            name: 'alarmVoice',
            title: '告警语音',
            component: alarmVoice,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'alarmSubscribe',
            name: 'alarmSubscribe',
            title: '告警订阅关系',
            component: alarmSubscribe,
            meta: {
              requireAuth: true
            }
          },
          {
            path: 'historySubscribe',
            name: 'historySubscribe',
            title: '历史订阅关系',
            component: historySubscribe,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'AiQuery',
        name: 'AiQuery',
        title: 'AI查询',
        component: AiQuery,
        meta: {
          requireAuth: true
        }
      }
    ]
  }
]

export const dynamicRoutes = [
  ...dynamicRoute1,
  ...dynamicRoute3,
  ...dynamicRoute4,
  ...dynamicRoute2
]

export const visualizeRoute = [
  {
    path: '/visualize',
    name: 'visualize',
    component: visualizeIndex,
    children: [
      {
        path: 'visualizeHome',
        name: 'visualizeHome',
        title: '可视化页面',
        component: () => import('@/components/visualize/visualizeHome/index'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'visualizeDqhz',
        name: 'visualizeDqhz',
        title: '电气火灾',
        component: () => import('@/components/visualize/visualizeDqhz/index'),
        meta: {
          requireAuth: true
        }
      }
    ]
  }
]

export const fireStationRoute = [
  {
    path: '/fireStation',
    name: 'fireStation',
    component: fireStation
  }
]
export const visualizeWrjRoute = [
  {
    path: '/visualizeWrj',
    name: 'droneVisualize',
    component: visualizeWrj
  }
]
export const visualizeWrj2Route = [
  {
    path: '/visualizeWrj2',
    name: 'visualizeWrj2',
    component: visualizeWrj2
  }
]

export const spacerBarRoute = [
  {
    path: '/spacerBar',
    name: 'spacerBar',
    component: spacerBar
  }
]

export const pumpMonitorRoute = [
  {
    path: '/pumpMonitor',
    name: 'pumpMonitor',
    component: pumpMonitor
  }
]

export const waterSystemRoute = [
  {
    path: '/waterSystem',
    name: 'waterSystem',
    component: waterSystem
  }
]

export const waterSystemHomeRoute = [
  {
    path: '/waterSystemHome',
    name: 'waterSystemHome',
    component: waterSystemHome
  }
]

export const initialRoutes = [
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/gapSticklogin',
    name: 'gapSticklogin',
    component: gapSticklogin
  },
  {
    path: '/waterSystemlogin',
    name: 'waterSystemlogin',
    component: waterSystemlogin
  },
  {
    path: '/accesslogin',
    name: 'accessLogin',
    component: accessLogin
  },
  {
    path: '/demo',
    name: 'demo',
    component: demo
  },
  {
    path: '/admin',
    name: 'admin',
    component: admin
  },
  {
    path: '/changePsw',
    name: 'changePsw',
    component: changePsw
  },
  {
    path: '/dailySchedule',
    name: 'dailySchedule',
    title: '每日计划',
    component: dailySchedule,
    meta: {
      title: '每日计划',
      requireAuth: true
    }
  },
  {
    path:
      '/systemConfiguration/allSystemConfiguration/device/allDevice/device/tridev/:id/:device_type',
    name: 'tridev',
    title: 'tridev',
    component: tridev,
    meta: {
      requireAuth: true
    }
  },
  {
    path:
      '/systemConfiguration/allSystemConfiguration/device/allDevice/device/tridev/add/:relevanceType/:id/:device_type',
    name: 'tridevAdd',
    title: 'tridevAdd',
    component: tridevAdd,
    meta: {
      requireAuth: true
    }
  },

  {
    path: '/system/concatUser/:id/:groupName',
    name: 'concatUser',
    title: '关联用户',
    component: concatUser,
    meta: {
      requireAuth: true
    }
  },

  {
    path: '/mission/allMission/mission/personnel/:id',
    name: 'personnel',
    title: '人员管理',
    component: personnel,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/systemConfiguration/allSystemConfiguration/system/region/edit',
    name: 'editRegion',
    title: '区域修改',
    component: () =>
      import('@/components/dynamicRoute2/systemConfiguration/first/system/region/edit'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/systemConfiguration/allSystemConfiguration/system/region/add',
    name: 'addRegion',
    title: '区域新增',
    component: () =>
      import('@/components/dynamicRoute2/systemConfiguration/first/system/region/add'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/management/allManagement/levelUp',
    name: 'levelUp',
    title: '升级步骤',
    component: () => import('@/components/dynamicRoute3/management/levelUp/index'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/detail',
    name: 'detail',
    title: '设备详情',
    component: () => import('@/components/public/detail/index.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/login/loginLoading/:auto',
    name: 'loading',
    title: '登录过渡页',
    component: () => import('@/components/password/login/loginLoading.vue')
  },
  {
    path: '/maintenance/projectManage/wbPlan/planDetail',
    name: 'planDetail',
    title: '计划详情',
    component: () => import('@/components/maintenance/projectManage/wbPlan/planDetail'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/maintenance/projectManage/wbOrder/taskDetail',
    name: 'taskDetail',
    title: '工单详情',
    component: () => import('@/components/maintenance/projectManage/wbOrder/taskDetail'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/systemConfiguration/allSystemConfiguration/system/allSystem/system/region/adjustment',
    name: '区域调整',
    title: '区域调整',
    component: () =>
      import(
        '@/components/dynamicRoute2/systemConfiguration/first/system/region/update/areaNodeUpdate'
      ),
    meta: {
      requireAuth: true
    }
  }
]
export default new Router({
  routes: [...initialRoutes]
})



// WEBPACK FOOTER //
// ./src/router/index.js